"use client";
import React, { useState } from "react";
import plumeria_snap from "../../components/assets/plumeria-pdf-snap.png";
import { CardBody, CardContainer, CardItem } from "./plumeria3d";
import Plumeria_Brochure from "../../components/assets/RRPL_Plumeria_PDF.pdf"
import ContactModal from "../Modal/contactModal";
export function ThreeDCardDemo() {
  const [showModal,setShowModal]=useState(false);
  const handleOpenModal=()=> setShowModal(true);
  const handleCloseModal=()=> setShowModal(false);
  const handleDownloadBrochure=()=>{
    window.open(Plumeria_Brochure,"_blank");
  }
  return (
    <CardContainer className="inter-var">
      <CardBody className="bg-gray-50 relative group/card  dark:hover:shadow-2xl dark:hover:shadow-emerald-500/[0.1] dark:bg-black dark:border-white/[0.2] border-black/[0.1] w-auto sm:w-[30rem] h-auto rounded-xl p-6 border  ">
        <CardItem
          translateZ="50"
          className="text-xl font-bold text-neutral-600 dark:text-white"
        >
          Get Your Brochure in a Click!
        </CardItem>
        <CardItem
          as="p"
          translateZ="60"
          className="text-neutral-500 text-sm max-w-sm mt-2 dark:text-neutral-300"
        >
          Discover the Perfect Plot for Your Next Move!
        </CardItem>
        <CardItem translateZ="100" className="w-full mt-4">
          <img
            src={plumeria_snap}
            height="1000"
            width="1000"
            className="h-60 w-full object-cover rounded-xl group-hover/card:shadow-xl"
            alt="thumbnail"
          />
        </CardItem>
        <div className="flex justify-center items-center mt-20">
          <CardItem
            translateZ={20}
            as="button"
            className="px-4 py-2 rounded-xl bg-[#0b3d2c] text-[#d3b66d] text-xs font-bold"
            onClick={handleOpenModal}
          >
            Download Brochure
          </CardItem>
        </div>
      </CardBody>
      {showModal && (
        <ContactModal
         show={showModal}
         handleClose={handleCloseModal}
         onSubmitSuccess={handleDownloadBrochure}
         project="Plumeria"
        />
      )}
    </CardContainer>
  );
}
